import PropTypes from 'prop-types';
import React from 'react';
import classname from 'classname';
import ClickOutside from 'react-onclickoutside';

class Popover extends React.Component {
	render() {
		const className = classname({
			'popover-wrap': true,
			'is-show': this.props.isShow
		});

		return (
			<div className={className}>
				<div className="popover-wrap__head">
					{ this.props.head }
				</div>
				<div className="popover-wrap__body">
					{ this.props.isShow && this.props.children}
				</div>
			</div>
		);
	}

	handleClickOutside(e) {
		if (this.props.isShow && this.props.onOutSideClick) {
			this.props.onOutSideClick();
		}
	}
}

Popover.propTypes = {
	isShow: PropTypes.bool,
	onOutSideClick: PropTypes.func,
	children: PropTypes.node.isRequired,
	head: PropTypes.element
};

export default ClickOutside(Popover);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/popover.js